<div class="search-address">
  <mat-form-field floatLabel="never" class="search-input">
    <input title="search-term" matInput [placeholder]="placeholder" #searchTerm [formControl]="searchControl" [matAutocomplete]="auto" />
    <mat-autocomplete panelWidth="auto" #auto="matAutocomplete" [displayWith]="displayFn" (optionSelected)="navigate($event.option.value)">
      <mat-option *ngFor="let option of filteredOptions | async" [value]="option">
        {{ option.suggestion }}
      </mat-option>
    </mat-autocomplete>
    <mat-icon matSuffix (click)="search(searchTerm.value)"><span class="fa fa-search" aria-hidden="true"></span></mat-icon>
  </mat-form-field>
</div>
